import { render, staticRenderFns } from "./AnimalAvatarInfoCell.vue?vue&type=template&id=276161a0&scoped=true&"
import script from "./AnimalAvatarInfoCell.vue?vue&type=script&lang=js&"
export * from "./AnimalAvatarInfoCell.vue?vue&type=script&lang=js&"
import style0 from "./AnimalAvatarInfoCell.vue?vue&type=style&index=0&id=276161a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276161a0",
  null
  
)

export default component.exports